import { render, staticRenderFns } from "./ProjectEditReportsTab.vue?vue&type=template&id=23224dce"
import script from "./ProjectEditReportsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectEditReportsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports